import React, { useRef } from 'react';
import "../../../styles/educationPage.css";
import education from '../../../assets/edu.jpg';
import { educationArray } from './educationData';
import { motion, useScroll, useTransform } from 'framer-motion';

export const Education: React.FC = () => {
    const ref = useRef(null);
       const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"]
    });
    const paralaxY = useTransform(scrollYProgress, [0, 1], [100, -500]);
 
    return (
        <div className='z-10 bg-darkPrimary h-[110vh] w-full flex justify-between'
            id="education" ref={ref}>
            <div className='lg:w-2/3 w-full h-full flex flex-col justify-center items-center lg:p-32 p-12 '>
                <header className='w-full lg:my-20 my-10 lg:text-base text-sm'>
                    <motion.span className='text-gray-400'
                        initial={{ y: 40, opacity: 0, filter: "blur(20px)" }}
                        whileInView={{ y: 0, opacity: 1, filter: "blur(0px)" }}
                        transition={{ duration: .5, delay: .2 }}
                    >Intellectual growth should commence at birth and cease only at death - Albert Einstein</motion.span>
                    <motion.h1 className='lg:text-4xl text-2xl font-bold lg:mb-12 mt-6 relative tittle text-white'
                        initial={{ y: 40, opacity: 0, filter: "blur(20px)" }}
                        whileInView={{ y: 0, opacity: 1, filter: "blur(0px)" }}
                        transition={{ duration: .5, delay: .3 }}
                    >How it
                        <span className='text-primary lg:text-5xl text-4xl font-[Titillium] lowercase italic'> started </span></motion.h1>
                    <motion.p
                        className='text-justify text-gray-400 lg:inline hidden'
                        initial={{ y: 40, opacity: 0, filter: "blur(20px)" }}
                        whileInView={{ y: 0, opacity: 1, filter: "blur(0px)" }}
                        transition={{ duration: .5, delay: .4 }}
                    >Before I ever wrote a line of code, I was learning how to see.
                        From emergency medicine to fine arts, from photo labs to creative studios—each
                        step taught me to notice the details, trust the process, and stay curious.
                        Somewhere along the way, curiosity became craft, and craft became code.
                        The journey was never linear—but that's what made it mine.
                    </motion.p>
                </header>
                <main className='z-10 w-full flex flex-col text-white text-xl justify-between relative'>
                    {educationArray.map((e, index) => {
                        return <motion.div className='educationSection'
                            initial={{y: 40, opacity: 0 }}
                            whileInView={{y: 0, opacity: 1 }}
                            transition={{
                            duration: 0.45,
                            delay: (index / 10) + .3,
                            }}>
                        <p>{e.data}</p>
                        <h2 className={e.isTitle ? 'text-primary' : ''}>{e.name}</h2>
                        <p>{e.school}</p>
                    </motion.div>
                    })}
                </main>
            </div>
            <div className='w-1/3 h-full lg:flex hidden relative items-end justify-end overflow-hidden'>
            <div className='educationImg top-0 right-0 w-[150%] h-auto bg-bottom absolute'>
                 <motion.img src={education} className="block scale-150" alt="aboutMe" style={{y: paralaxY}}
                  transition={{ ease: "easeOut", duration: 0.5 }}/>
            </div>
            </div>
        </div>
    )
}